// extracted by mini-css-extract-plugin
export default {"enrichment_favicon":"enrichment-favicon_enrichment_favicon__3PP49","value_with_button":"enrichment-favicon_value_with_button__ImvgR"};